module.exports = __webpack_public_path__ + "static/media/20.b9ded278.jpg";